(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-hero"]) return;
  try {
    
      var select = document.querySelector('select#navigate-blogs');
      select.addEventListener('change', function() {
        var nextPage = select.value;
        window.location.href = nextPage;
      });
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-hero"]) return;
  try {
    
      var select = document.querySelector('select#navigate-blogs');
      select.addEventListener('change', function() {
        var nextPage = select.value;
        window.location.href = nextPage;
      });
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jump-to-section"] && !window.DesignMode) return;
  try {
    
    var select = document.querySelector('select#page-jump');
    select.addEventListener('change', function() {
      var sectionId = select.value;
      var section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-rewards-faqs"]) return;
  try {
    


var acc = document.getElementsByClassName("accordion_title");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    /* Toggle between adding and removing the "active" class,
    to highlight the button that controls the panel */
    this.classList.toggle("active");
    this.firstElementChild.classList.toggle("icon-arrow-up");
    this.firstElementChild.classList.toggle("icon-arrow-down");

    /* Toggle between hiding and showing the active panel */
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

 

  } catch(e) { console.error(e); }
})();
})();
